import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "text-left" }
const _hoisted_2 = { class: "truncate font-medium text-gray-900 dark:text-white" }
const _hoisted_3 = { class: "truncate" }


export default /*@__PURE__*/_defineComponent({
  __name: 'userDropdown',
  setup(__props) {

const auth = useAuthStore();
const { toggleChat, isChatOpen } = useLazyCrisp();

// Stable handler references — same function object across renders
const handleChatSelect = () => toggleChat();
const handleLogout = () => auth.logout();

// Static menu sections that never change (markRaw avoids deep reactivity overhead)
const accountSection = markRaw([
  {
    slot: "account",
    label: "",
    disabled: true,
  },
]);

const profileSection = markRaw([
  {
    label: "My Profile",
    icon: "i-heroicons-user",
    to: `/user/profile/${auth.user?.id}`,
  },
  {
    label: "Settings",
    icon: "i-heroicons-cog-8-tooth",
    to: "/settings",
  },
]);

const upgradeSection = markRaw(
  auth.user?.role === "owner"
    ? [
        {
          label: "Upgrade Your Plan",
          icon: "i-heroicons-credit-card",
          to: "/settings/billing",
          target: "_self",
        },
      ]
    : [],
);

const helpSection = markRaw([
  {
    label: "Help & Support",
    icon: "i-heroicons-book-open",
    to: "/help",
    target: "_self",
  },
]);

const logoutSection = markRaw([
  {
    label: "Sign Out",
    icon: "i-heroicons-arrow-left-on-rectangle",
    onSelect: handleLogout,
  },
]);

// Only the chat item is reactive — computed re-evaluates ONLY when isChatOpen changes
const chatItem = computed(() =>
  markRaw({
    label: isChatOpen.value ? "Close Chat" : "Chat with Support",
    icon: isChatOpen.value ? "i-heroicons-x-mark" : "i-heroicons-chat-bubble-left-right",
    onSelect: handleChatSelect,
  }),
);

// Assemble final items — static sections are stable references, only chatItem changes
const items = computed(() => [
  accountSection,
  [...profileSection, ...upgradeSection],
  [...helpSection, chatItem.value],
  logoutSection,
]);

return (_ctx: any,_cache: any) => {
  const _component_UAvatar = _resolveComponent("UAvatar")!
  const _component_UIcon = _resolveComponent("UIcon")!
  const _component_UDropdownMenu = _resolveComponent("UDropdownMenu")!

  return (_unref(auth).user)
    ? (_openBlock(), _createBlock(_component_UDropdownMenu, {
        key: 0,
        mode: "click",
        items: _unref(items),
        popper: { placement: 'bottom-start' }
      }, {
        account: _withCtx(({ item }) => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("p", null, "Signed in as " + _toDisplayString(_unref(auth).user?.firstname) + " " + _toDisplayString(_unref(auth).user?.surname), 1),
            _createElementVNode("p", _hoisted_2, _toDisplayString(item.label), 1)
          ])
        ]),
        item: _withCtx(({ item }) => [
          _createElementVNode("span", _hoisted_3, _toDisplayString(item.label), 1),
          ('icon' in item)
            ? (_openBlock(), _createBlock(_component_UIcon, {
                key: 0,
                name: item.icon,
                class: "shrink-0 h-4 w-4 text-gray-400 dark:text-gray-500 ms-auto"
              }, null, 8, ["name"]))
            : _createCommentVNode("", true)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_UAvatar, {
            src: 
        _unref(auth).user?.avatar
          ? _unref(auth).user?.avatar
          : `https://api.dicebear.com/9.x/avataaars/svg?seed=${_unref(auth).user?.firstname}${_unref(auth).user?.surname}&flip=false`
      ,
            class: "hover:border-blue-700 hover:border-2 box-border hover:cursor-pointer",
            size: "md"
          }, null, 8, ["src"])
        ]),
        _: 1
      }, 8, ["items"]))
    : _createCommentVNode("", true)
}
}

})